export default {
    modalShowImageVariations: {
        imageAi: 'Bilde AI',
        regenerateImage: 'Generer nytt innhold',
        description: 'Beskrivelse',
        style: 'Stil',
        saveToLibrary: 'Lagre til bibliotek',
        continue: 'Fortsett',
        cancel: 'Avbryt',
        select: 'Velg',
        copy: 'Kopier',
        selectedImage: 'Valgt Bilde',
        saved: 'Lagret',
        variations: 'Varianter',
    },
};
